import type { DividerData } from 'ricos-schema';
import {
  DividerData_Alignment,
  DividerData_LineStyle,
  DividerData_Width,
  Node_Type,
} from 'ricos-schema';

import type { NodeBuilder } from './types';
import { isDefined } from './utils';

export const divider = (...args: (NodeBuilder | DividerData)[]): NodeBuilder => {
  const dividerData = args.find((a): a is DividerData => !('type' in a));

  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.DIVIDER,
      nodes: args
        .map(arg => ('type' in arg && arg.type === 'block_node' ? arg.node(getId) : undefined))
        .filter(isDefined),
      dividerData: dividerData
        ? dividerData
        : {
            lineStyle: DividerData_LineStyle.SINGLE,
            width: DividerData_Width.LARGE,
            alignment: DividerData_Alignment.CENTER,
          },
    }),
  };
};
